/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import {
  FormControl,
} from '@material-ui/core';
import { change, reduxForm } from 'redux-form';
import { defineMessages, injectIntl } from 'react-intl';
import AsyncSelect from 'react-select/async';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const messages = defineMessages({
  typeoftraining: {
    id: 'CoursePlan.typeoftraining',
    defaultMessage: 'Course type',
  },
  individual: {
    id: 'CoursePlan.individual',
    defaultMessage: 'Individual lessons',
  },
  inperson: {
    id: 'CoursePlan.inperson',
    defaultMessage: 'Face to Face lessons',
  },
  group: {
    id: 'CoursePlan.group',
    defaultMessage: 'Group lessons',
  },
  phone: {
    id: 'CoursePlan.phone',
    defaultMessage: 'Telephone course',
  },
  blended: {
    id: 'CoursePlan.blended',
    defaultMessage: 'Blended learning',
  },
  intensive: {
    id: 'CoursePlan.intensive',
    defaultMessage: 'Intensive course',
  },
  elearning: {
    id: 'CoursePlan.elearning',
    defaultMessage: 'E-learning',
  },
  video: {
    id: 'CoursePlan.video',
    defaultMessage: 'Video lessons',
  },
});

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '56px',
    fontSize: '16px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
  container: (base) => ({ ...base, zIndex: 50 }),
};

const CoursePlanTraining = (props) => {
  const [selectValue, setSelectValue] = useState([]);
  const {
    dispatch, form, intl, initialValues, dataform,
  } = props;

  useEffect(() => {
    if (dataform && dataform.values.typeoftraining) {
      const op = [];
      dataform.values.typeoftraining.forEach((element) => {
        op.push({ value: element, label: intl.formatMessage(messages[element]) });
      });
      setSelectValue(op);
    } else if (initialValues.typeoftraining) {
      const op = [];
      initialValues.typeoftraining.forEach((element) => {
        op.push({ value: element, label: intl.formatMessage(messages[element]) });
      });
      setSelectValue(op);
    }
  }, []);

  const data = [
    { value: 'individual', label: intl.formatMessage(messages.individual) },
    { value: 'inperson', label: intl.formatMessage(messages.inperson) },
    { value: 'group', label: intl.formatMessage(messages.group) },
    { value: 'phone', label: intl.formatMessage(messages.phone) },
    { value: 'blended', label: intl.formatMessage(messages.blended) },
    { value: 'intensive', label: intl.formatMessage(messages.intensive) },
    { value: 'elearning', label: intl.formatMessage(messages.elearning) },
    { value: 'video', label: intl.formatMessage(messages.video) }];

  const noOptionsMessage = () => intl.formatMessage(messages.typeoftraining);

  const handleItemSelectChange = (option) => {
    const op = [];
    option.forEach((element) => {
      op.push(element.value);
    });
    dispatch(change(`${form}`, 'typeoftraining', op));
    setSelectValue(option);
  };

  return (
    <FormControl variant="outlined" style={{ width: '100%' }}>
      <AsyncSelect
        isMulti
        closeMenuOnSelect={false}
        cacheOptions
        styles={customStyles}
        onChange={(option) => handleItemSelectChange(option)}
        defaultOptions
        loadOptions={(query, callback) => callback(data)}
        classNamePrefix="react-Selector"
        value={selectValue}
        noOptionsMessage={noOptionsMessage}
      />
    </FormControl>
  );
};

CoursePlanTraining.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.any.isRequired,
  form: PropTypes.any.isRequired,
  initialValues: PropTypes.any.isRequired,
  dataform: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return { initialValues: state.group.selectedGroup, form: name, dataform };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(injectIntl(CoursePlanTraining));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default NewconnectedGroupForm;
